import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';

export const FatherAge = () => {
    const { chartData } = useParentsInfoChartsDataContext();


    return (
        <SimpleBars
            title={'Idade do Pai'}
            horizontal={false}
            subtitles={chartData?.fatherAge?.map((item) => item.description)}
            values={chartData?.fatherAge?.map((item) => item.total  ||  0)}
        />
    );
};
